import { authHeader } from "../_helpers";
import config from "../config";
import { handleResponse } from "../_helpers/response";

const baseUrl = config.apiGateway.baseUrl;

export const faceSearchService = {
  saveFaceSearchAllocation,
  getFaceSearchAllocation,
  updateFaceSearchAllocation,
  citieswiseFaceSearchAllocation,
  uploadFaceSearchImage,
  createFindFaceSearch,
  getFindFaceSearchCityWise,
  getFindFaceSearchId,
  getFaceSearchDetails,
};

function saveFaceSearchAllocation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/face/allocation/`, requestOptions).then(
    handleResponse,
  );
}
function getFaceSearchAllocation() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/face/allocation/list`, requestOptions).then(
    handleResponse,
  );
}
function updateFaceSearchAllocation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/face/allocation/update`, requestOptions).then(
    handleResponse,
  );
}
function citieswiseFaceSearchAllocation(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/face/allocation/citieswise/${cityId}`,
    requestOptions,
  ).then(handleResponse);
}
function uploadFaceSearchImage(file) {
  const formData = new FormData();
  formData.append("profileImage", file);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };
  return fetch(`${baseUrl}/face/face-img-upload`, requestOptions).then(
    handleResponse,
  );
}

function createFindFaceSearch(values) {
  const formData = new FormData();
  const { image_file, ...fields } = values;

  if (image_file) {
    formData.append("image_file", image_file);
  }

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      formData.append(key, value);
    }
  });

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
    },
    body: formData,
  };
  return fetch(`${baseUrl}/face/find/create`, requestOptions).then(
    handleResponse,
  );
}
function getFindFaceSearchCityWise(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/face/find/list/${id}`, requestOptions).then(
    handleResponse,
  );
}
function getFindFaceSearchId(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/face/find/id/${id}`, requestOptions).then(
    handleResponse,
  );
}
function getFaceSearchDetails(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/face/find/search/${id}`, requestOptions).then(
    handleResponse,
  );
}
